'use client'

import classNames from 'classnames'

export type ChatCountDotStyleProps = {
  className?: string
  color?: 'primary' | 'secondary'
}

export type ChatCountDotProps = ChatCountDotStyleProps & {
  count: number
  'aria-label': string
}

const ChatCountDot = ({
  color = 'primary',
  count,
  className,
  ...props
}: ChatCountDotProps) => {
  const isVisible = count > 0
  const showPlus = count > 9

  return (
    <span
      className={classNames(
        'chatCountDot',
        color,
        showPlus && 'small',
        className
      )}
      data-is-visible={isVisible}
      data-has-unread-messages
      {...props}
    >
      {showPlus ? '9+' : count}
    </span>
  )
}

export default ChatCountDot
